/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function CustomFormattedMessage({ message, children }) {
  return (
    <FormattedMessage
      id={message.id}
      defaultMessage={message.defaultMessage}
      description={message.description}
      values={message.values}
      tagName={message.tagName}
    >
      {children}
    </FormattedMessage>
  );
}

CustomFormattedMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
    description: PropTypes.string,
    values: PropTypes.shape({}),
    tagName: PropTypes.elementType,
  }).isRequired,
  children: PropTypes.func,
};

CustomFormattedMessage.defaultProps = {
  children: undefined,
};

export default memo(CustomFormattedMessage);
